import { createFileRoute } from '@tanstack/react-router'

import { TenantUsersPage } from '@/pages/tenants/detail/TenantUsersPage'

export const Route = createFileRoute('/_authenticated/tenants/$id/users')({
  component: TenantUsersPage,
})
